import { useState } from 'react'

import {
    ArrowsClockwise,
    X,
    Image,
    Trash,
    QrCode,
    CaretDown,
    PencilSimple,
    DownloadSimple,
    DotsThreeVertical,
} from '@phosphor-icons/react'

import './OutletSetupPage.scss'

export default function OutletSetupPage() {

	const times = [
        '9:00 am',
        '10:00 am',
        '11:00 am',
        '12:00 pm',
        '1:00 pm',
        '2:00 pm',
        '3:00 pm',
        '4:00 pm',
        '5:00 pm',
        '6:00 pm',
        '7:00 pm',
        '8:00 pm',
        '9:00 pm',
    ]

    const [openMenu, setOpenMenu] =
        useState(null)

    const [showCreateModal, setShowCreateModal] =
        useState(false)

    const [showEditModal, setShowEditModal] =
        useState(false)

    const [selectedTable, setSelectedTable] =
        useState(null)

    const [newTable, setNewTable] =
        useState({
            name: '',
            pax: '',
        })

    const [serviceHours, setServiceHours] =
        useState([
            {
                day: 'Monday',
                enabled: true,
                open: '9:00 am',
                close: '5:00 pm',
            },
            {
                day: 'Tuesday',
                enabled: true,
                open: '9:00 am',
                close: '5:00 pm',
            },
            {
                day: 'Wednesday',
                enabled: false,
                open: '9:00 am',
                close: '5:00 pm',
            },
            {
                day: 'Thursday',
                enabled: true,
                open: '9:00 am',
                close: '5:00 pm',
            },
            {
                day: 'Friday',
                enabled: true,
                open: '9:00 am',
                close: '5:00 pm',
            },
            {
                day: 'Saturday',
                enabled: true,
                open: '9:00 am',
                close: '5:00 pm',
            },
            {
                day: 'Sunday',
                enabled: false,
                open: '9:00 am',
                close: '5:00 pm',
            },
        ])

    const toggleDay = (index) => {
        setServiceHours((prev) =>
            prev.map((item, i) =>
                i === index
                    ? {
                          ...item,
                          enabled: !item.enabled,
                      }
                    : item
            )
        )
    }

    const updateTime = (
        index,
        field,
        value
    ) => {
        setServiceHours((prev) =>
            prev.map((item, i) =>
                i === index
                    ? {
                          ...item,
                          [field]: value,
                      }
                    : item
            )
        )
    }

    const tables = [
        {
            code: 'T01',
            name: 'Table 1',
            pax: '4 pax',
        },
        {
            code: 'T02',
            name: 'Table 2',
            pax: '4 pax',
        },
        {
            code: 'T03',
            name: 'Table 3',
            pax: '6 pax',
        },
        {
            code: 'T04',
            name: 'Table 4',
            pax: '4 pax',
        },
        {
            code: 'T05',
            name: 'Table 5',
            pax: '4 pax',
        },
        {
            code: 'T06',
            name: 'Table 6',
            pax: '4 pax',
        },
        {
            code: 'T07',
            name: 'Table 7',
            pax: '6 pax',
        },
        {
            code: 'T08',
            name: 'Table 8',
            pax: '10 pax',
        },
    ]

    return (
        <div className="outlet-setup-page">
            <div className="page-header">
                <div>
                    <div className="page-breadcrumb">
                        Hikaya House /{' '}
                        <span>
                            Outlet setup
                        </span>
                    </div>

                    <h1>Outlet setup</h1>

                    <p>
                        Outlet information
                        and table QR
                        information
                    </p>
                </div>

                <button className="btn-primary">
                    Save changes
                </button>
            </div>

            <div className="setup-card">
                <h2>
                    Outlet information
                </h2>

                <div className="form-group">
                    <label>
                        Outlet name
                    </label>

                    <input
                        type="text"
                        value="KLCC Branch"
                    />
                </div>

                <div className="form-group">
                    <label>
                        Outlet image
                    </label>

                    <div className="upload-box">
                        <Image size={40} />

                        <h4>
                            Drop image or
                            click to upload
                        </h4>

                        <p>
                            JPG, PNG or
                            WEBP ・ max 5MB
                            ・ 800x600
                            recommended
                        </p>
                    </div>
                </div>

                <div className="form-group">
                    <label>Address</label>

                    <textarea>
                        Level 4, Suria
                        KLCC, KL
                    </textarea>
                </div>

                <div className="form-group">
                    <label>
                        Google maps URL
                    </label>

                    <input
                        type="text"
                        value="https://maps.google.com/?q=Hikari-House+KLCC"
                    />
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>
                            Latitude
                        </label>

                        <input
                            type="text"
                            value="3.1579"
                        />
                    </div>

                    <div className="form-group">
                        <label>
                            Longitude
                        </label>

                        <input
                            type="text"
                            value="101.7116"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Phone</label>

                        <input
                            type="text"
                            value="+60 323828899"
                        />
                    </div>

                    <div className="form-group">
                        <label>Email</label>

                        <input
                            type="text"
                            placeholder="email"
                        />
                    </div>
                </div>
            </div>

            <div className="setup-card">
              <h2>Business hours</h2>

              <div className="outlet-hours">
                {/* HEADER */}
                <div className="outlet-hours__header">
                  <div />
                    <span>Business hours</span>
                    <span>Ordering hours</span>
                </div>

                {serviceHours.map((day, index) => (
                  <div
                    key={day.day}
                    className="outlet-hours__row"
                  >
                    {/* DAY */}
                    <div className="outlet-hours__day">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={day.enabled}
                          onChange={() =>
                            toggleDay(index)
                          }
                        />

                        <span className="slider" />
                      </label>

                      <span>{day.day}</span>
                    </div>

                    {/* HOURS */}
                    {day.enabled ? (
                      <div className="outlet-hours__columns">
                        {/* BUSINESS HOURS */}
                        <div className="outlet-hours__time">
                          <div className="outlet-hours__select">
                            <select
                              value={day.open}
                              onChange={(e) =>
                                updateTime(
                                  index,
                                  'open',
                                  e.target.value
                                )
                              }
                            >
                              {times.map((time) => (
                                <option
                                  key={time}
                                  value={time}
                                >
                                  {time}
                                </option>
                              ))}
                            </select>

                            <CaretDown size={18} />
                          </div>

                          <div className="outlet-hours__dash">
                            -
                          </div>

                          <div className="outlet-hours__select">
                            <select
                              value={day.close}
                              onChange={(e) =>
                                updateTime(
                                  index,
                                  'close',
                                  e.target.value
                                )
                              }
                            >
                              {times.map((time) => (
                                <option
                                  key={time}
                                  value={time}
                                >
                                  {time}
                                </option>
                              ))}
                            </select>

                            <CaretDown size={18} />
                          </div>
                        </div>

                        {/* ORDERING HOURS */}
                        <div className="outlet-hours__time">
                          <div className="outlet-hours__select">
                            <select defaultValue="9:00 am">
                              {times.map((time) => (
                                <option
                                  key={time}
                                  value={time}
                                >
                                  {time}
                                </option>
                              ))}
                            </select>

                            <CaretDown size={18} />
                          </div>

                          <div className="outlet-hours__dash">
                            -
                          </div>

                          <div className="outlet-hours__select">
                            <select defaultValue="10:00 pm">
                              {times.map((time) => (
                                <option
                                  key={time}
                                  value={time}
                                >
                                  {time}
                                </option>
                              ))}
                            </select>

                            <CaretDown size={18} />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="outlet-hours__closed">
                        Closed
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="setup-card">
                <div className="qr-header">
                    <h2>Table QR codes</h2>

                    <div className="qr-actions">
                        <button className="btn-secondary">
                            <DownloadSimple
                                size={18}
                            />
                            Download all
                        </button>

                        <button
                            className="btn-primary"
                            onClick={() =>
                                setShowCreateModal(
                                    true
                                )
                            }
                        >
                            <ArrowsClockwise size={18} />
                            Sync POS
                        </button>
                    </div>
                </div>

                <div className="qr-grid">
                    {tables.map((table) => (
                        <div
                            className="qr-card"
                            key={table.id}
                        >
                            <div className="qr-placeholder">
                                QR
                            </div>

                            <p>
                                {table.name} ・{' '}
                                {table.pax}
                            </p>

                            <div className="qr-card__actions">
                                <button className="download-btn">
                                    <DownloadSimple
                                        size={18}
                                    />
                                    Download
                                </button>

                                <div className="qr-menu">
                                    <button
                                        className="menu-btn"
                                        onClick={() =>
                                            setOpenMenu(
                                                openMenu ===
                                                    table.code
                                                    ? null
                                                    : table.code
                                            )
                                        }
                                    >
                                        <DotsThreeVertical
                                            size={
                                                18
                                            }
                                        />
                                    </button>

                                    {openMenu ===
                                        table.code && (
                                        <div className="qr-dropdown">
{/*                                            <button
                                                onClick={() => {
                                                    setSelectedTable(
                                                        table
                                                    )

                                                    setShowEditModal(
                                                        true
                                                    )

                                                    setOpenMenu(
                                                        null
                                                    )
                                                }}
                                            >
                                                <PencilSimple
                                                    size={
                                                        18
                                                    }
                                                />
                                                Edit
                                            </button>*/}

                                            <button>
                                                <QrCode
                                                    size={
                                                        18
                                                    }
                                                />
                                                Regenerate
                                                QR
                                            </button>

{/*                                            <button className="danger">
                                                <Trash
                                                    size={
                                                        18
                                                    }
                                                />
                                                Delete
                                            </button>*/}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {showCreateModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>
                                Create table
                            </h3>

                            <button
                                onClick={() =>
                                    setShowCreateModal(
                                        false
                                    )
                                }
                            >
                                <X
                                    size={20}
                                />
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="form-group">
                                <label>
                                    Table number
                                </label>

                                <input
                                    type="text"
                                    placeholder="e.g. Table No.3 ( Window )"
                                />
                            </div>

                            <div className="form-group">
                                <label>
                                    Capacity (pax)
                                </label>

                                <input
                                    type="text"
                                    placeholder="e.g. 4"
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn-secondary"
                                onClick={() =>
                                    setShowCreateModal(
                                        false
                                    )
                                }
                            >
                                Cancel
                            </button>

                            <button className="btn-primary">
                                Create &
                                generate QR
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showEditModal &&
                selectedTable && (
                    <div className="modal-overlay">
                        <div className="modal">
                            <div className="modal-header">
                                <h3>
                                    Edit
                                    table
                                </h3>

                                <button
                                    onClick={() =>
                                        setShowEditModal(
                                            false
                                        )
                                    }
                                >
                                    <X
                                        size={20}
                                    />
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="form-group">
                                    <label>
                                        Table
                                        name
                                    </label>

                                    <input
                                        type="text"
                                        value={
                                            selectedTable.name
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setSelectedTable(
                                                {
                                                    ...selectedTable,
                                                    name: e
                                                        .target
                                                        .value,
                                                }
                                            )
                                        }
                                    />
                                </div>

                                <div className="form-group">
                                    <label>
                                        Capacity
                                        (pax)
                                    </label>

                                    <input
                                        type="text"
                                        value={
                                            selectedTable.pax
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setSelectedTable(
                                                {
                                                    ...selectedTable,
                                                    pax: e
                                                        .target
                                                        .value,
                                                }
                                            )
                                        }
                                    />
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn-secondary"
                                    onClick={() =>
                                        setShowEditModal(
                                            false
                                        )
                                    }
                                >
                                    Cancel
                                </button>

                                <button className="btn-primary">
                                    Save
                                    changes
                                </button>
                            </div>
                        </div>
                    </div>
                )}
        </div>
    )
}